module.exports = __webpack_public_path__ + "img/filter-type-mobility--active.85533387.svg";